import { humanizeDurationUnitMeasures } from '@ipfabric/utils/utils/humanizeDurationUnitMeasures';

export const uptimeToNumber = (value: string): number | null => {
  const split = value.split(',').filter((v) => v !== '');
  if (!split || !split.length) {
    return null;
  }
  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: big switch
  const seconds = split.reduce<number | null>((acc, val) => {
    try {
      const extract = val.match(/[0-9]+/);
      if (!extract || !extract.length) {
        return acc;
      }
      const number = Number(extract[0]);
      if (/year/.test(val)) {
        return (acc ?? 0) + number * (humanizeDurationUnitMeasures.y / 1000);
      }
      if (/month/.test(val)) {
        return (acc ?? 0) + number * (humanizeDurationUnitMeasures.mo / 1000);
      }
      if (/week/.test(val)) {
        return (acc ?? 0) + number * (humanizeDurationUnitMeasures.w / 1000);
      }
      if (/day/.test(val)) {
        return (acc ?? 0) + number * (humanizeDurationUnitMeasures.d / 1000);
      }
      if (/hour/.test(val)) {
        return (acc ?? 0) + number * (humanizeDurationUnitMeasures.h / 1000);
      }
      if (/minute/.test(val)) {
        return (acc ?? 0) + number * (humanizeDurationUnitMeasures.m / 1000);
      }
      if (/second/.test(val)) {
        return (acc ?? 0) + number;
      }
      return acc;
    } catch {
      return null;
    }
  }, null);
  if (seconds === null || Number.isNaN(seconds)) {
    return null;
  }
  return seconds;
};
